import { render, staticRenderFns } from "./comRcNu.vue?vue&type=template&id=5647bc84&scoped=true&"
import script from "./comRcNu.vue?vue&type=script&lang=js&"
export * from "./comRcNu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5647bc84",
  null
  
)

export default component.exports